// import { cookies } from "next/headers";
import { REAL_ESTATE_PARTNERS } from "@/app/[lang]/partners/real-estate-partners";
import { NextResponse } from "next/server";

const PARTNER_COOKIE_NAME = 'partner'
// const PARTNER_FILTERED_COOKIE_NAME = 'partner_filtered'
const BANNER_OPENED_COOKIE_NAME = 'partner_banner_opened'

export const catchInboundPartnerLink = (partnerId: string, response: NextResponse) => {
    response.cookies.set(PARTNER_COOKIE_NAME, partnerId.toLowerCase(), {
      path: '/',
      httpOnly: false,
      sameSite: 'lax',
      secure: true,
      maxAge: 60 * 60 * 24 * 30 // 30 days
    }),
    // response.cookies.set(PARTNER_FILTERED_COOKIE_NAME, 'true', {
    //   path: '/',
    //   httpOnly: false,
    //   sameSite: 'lax',
    //   secure: true,
    //   maxAge: 60 * 60 * 24 * 30 // 30 days
    // })
    response.cookies.set(BANNER_OPENED_COOKIE_NAME, 'true', {
      path: '/',
      httpOnly: false,
      sameSite: 'lax',
      secure: true,
      maxAge: 60 * 60 * 24 * 30 // 30 days
    })
}

export function getInboundPartnerId_clientSide() {
  if (typeof window === 'undefined') return
  const cookies = document.cookie.split(';')
  const partnerCookie = cookies.find(cookie => cookie.trim().startsWith(`${PARTNER_COOKIE_NAME}=`))
  if(!partnerCookie) return
  return partnerCookie.split('=')[1]
}
export async function getInboundPartnerId_serverSide() {
  const { cookies } = await import('next/headers');
  const cookieStore = await cookies()
  return cookieStore.get(PARTNER_COOKIE_NAME)?.value
}
export function getInboundPartner_clientSide() {
  const partnerId = getInboundPartnerId_clientSide()
  if(!partnerId) return
  return REAL_ESTATE_PARTNERS.find(p => p.id === partnerId)
}
export async function getInboundPartner_serverSide() {
  const partnerId = await getInboundPartnerId_serverSide()
  if(!partnerId) return
  return REAL_ESTATE_PARTNERS.find(p => p.id === partnerId)
}

export function isPartnerFiltered_clientSide() {
  return true
  // if (typeof window === 'undefined') return false
  // const cookies = document.cookie.split(';')
  // const filteredCookie = cookies.find(cookie => cookie.trim().startsWith(`${PARTNER_FILTERED_COOKIE_NAME}=`))
  // if(!filteredCookie) return false
  // return filteredCookie.split('=')[1] === 'true'
}
export function stopPartnerFiltering_clientSide() {
  return
  // if (typeof window === 'undefined') return
  // document.cookie = `${PARTNER_FILTERED_COOKIE_NAME}=false; path=/; max-age=${60 * 60 * 24 * 365}; secure; samesite=lax`
}

export function isBannerOpened_clientSide() {
  const cookies = document.cookie.split(';')
  const openedCookie = cookies.find(cookie => cookie.trim().startsWith(`${BANNER_OPENED_COOKIE_NAME}=`))
  if(!openedCookie) return false
  return openedCookie.split('=')[1] === 'true'
}
export function closeBanner_clientSide() {
  document.cookie = `${BANNER_OPENED_COOKIE_NAME}=false; path=/; max-age=${60 * 60 * 24 * 365}; secure; samesite=lax`
}